module.exports = __webpack_public_path__ + "static/media/noun-tv-4765847-808080.31722586.svg";